import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { Conversation } from '@repo/shared/src/services/messaging-service/messaging-service.types';

export const initiateConversation = createAction(
  '[Conversation] Redirected from appointment',
  props<{ redirectedFromAppointment: boolean }>(),
);

export const setConversationSelected = createAction(
  '[Conversation] Set Conversation Selected',
  props<{ conversationSelected: Conversation | null }>(),
);

export const cancelGetConversationList = createAction('[Conversation] Cancel Get Conversation List');
export const cancelGetConversationListSuccess = createAction('[Conversation] Cancel Get Conversation List Success');

export const getConversationList = createAction(
  '[Conversation] Get Conversation List',
  props<{ isLoadingNeeded: boolean }>(),
);

export const getConversationListSuccess = createAction(
  '[Conversation] Get Conversation List Success',
  props<{ conversationList: Conversation[] }>(),
);

export const getConversationListFailed = createAction(
  '[Conversation] Get Conversation List Failed',
  props<{ error: any; isLoadingNeeded: boolean }>(),
);

export const deleteConversationFailed = createAction(
  '[Conversation] Delete Conversation Failed',
  props<{ error: any }>(),
);

export const updateConversation = createAction(
  '[Conversation] Update Conversation',
  props<{ changes: any; conversationId: string; conversation?: Conversation }>(),
);

export const updateConversationSuccess = createAction(
  '[Conversation] Update Conversation Success',
  props<{ conversationUpdated: Update<Conversation> }>(),
);

export const updateConversationFailed = createAction(
  '[Conversation] Update Conversation Failed',
  props<{ error: any }>(),
);

export const deleteConversation = createAction(
  '[Conversation] delete Conversation',
  props<{ conversationId: string }>(),
);

export const deleteConversationSuccess = createAction(
  '[Conversation] delete Conversation Success',
  props<{ conversationId: string }>(),
);

export const postConversation = createAction(
  '[Conversation] Post Conversation',
  props<{ /* message: any;  */ conversation: Conversation }>(),
);

export const postConversationSuccess = createAction(
  '[Conversation] Post Conversation Success',
  props<{ /* message: any; */ conversation: Conversation }>(),
);

export const postConversationFailed = createAction('[Conversation] Post Conversation Failed', props<{ error: any }>());
